import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Select,
    Button,
} from '../../ui/ot'
import {
    Table,
    TableBody,
    TableCell,
    TableRow,
} from "../../ui/table";
import { useTranslation } from "react-i18next";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
const LeaderGeneratorForm = ({
    keyPrefix = 'library.backstage.authorized_values_management',
    propsForm,
    field,
    onFormFinish = () => { },
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const [show, setShow] = useState(true)
    const { t } = useTranslation('translation', { keyPrefix })

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {
       

    };


    useEffect(() => {
        setDataInitialization();
    }, []);


    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                keyPrefix={keyPrefix}
                                field={field}
                                count={count}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    keyPrefix,
    field,
    initialValues = {},
}) => {
    const { t } = useTranslation('translation', { keyPrefix })


    return (
        <>
            <Row gutter={[4, 4]}>
                <Col span={24}>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell className="font-medium">0-4 紀錄長度</TableCell>
                                <TableCell>
                                    (自動填充)
                                    <Form.Item
                                        hidden={true}
                                        {...field}
                                        name={[field?.name ?? '', 'f0-4']}
                                        fieldKey={[field?.fieldKey ?? '', 'f0-4']}
                                        initialValue={initialValues?.['f0-4']}
                                    >
                                        <Input />
                                    </Form.Item>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="font-medium">5- 紀錄性質	</TableCell>
                                <TableCell>
                                    <Form.Item
                                        {...field}
                                        name={[field?.name ?? '', 'f5']}
                                        fieldKey={[field?.fieldKey ?? '', 'f5']}
                                        initialValue={initialValues?.f5}
                                    >
                                        <Select
                                            // onChange={(value) => {

                                            // }}
                                            options={[
                                                {
                                                    label: "a-有較高層次之紀錄",
                                                    value: "a"
                                                },
                                                {
                                                    label: "c-修正過之紀錄",
                                                    value: "c"
                                                },
                                                {
                                                    label: "d-刪除之紀錄",
                                                    value: "d"
                                                },
                                                {
                                                    label: "n-新紀錄",
                                                    value: "n"
                                                },
                                                {
                                                    label: "p-增訂預行編目資料之著錄層次",
                                                    value: "p"
                                                },
                                            ]}
                                        />
                                    </Form.Item>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="font-medium">6- 紀錄類型	</TableCell>
                                <TableCell>
                                    <Form.Item
                                        {...field}
                                        name={[field?.name ?? '', 'f6']}
                                        fieldKey={[field?.fieldKey ?? '', 'f6']}
                                        initialValue={initialValues?.f6}


                                    >
                                        <Select
                                            onChange={(value) => {

                                            }}
                                            options={[
                                                {
                                                    label: "a-文字資料",
                                                    value: "a"
                                                },
                                                {
                                                    label: "c-樂譜(一般)",
                                                    value: "c"
                                                },
                                                {
                                                    label: "d-樂譜(手稿)",
                                                    value: "d"
                                                },
                                                {
                                                    label: "e-地圖資料(印刷型式)",
                                                    value: "e"
                                                },
                                                {
                                                    label: "f-地圖資料(手稿)",
                                                    value: "f"
                                                },
                                                {
                                                    label: "g-放映性資料",
                                                    value: "g"
                                                },
                                                {
                                                    label: "i-錄音資料(非音樂性)",
                                                    value: "i"
                                                },
                                                {
                                                    label: "j-錄音資料(音樂性)",
                                                    value: "j"
                                                },
                                                {
                                                    label: "k-非放映性圖像資料",
                                                    value: "k"
                                                },
                                                {
                                                    label: "m-電腦檔案/電子資源",
                                                    value: "m"
                                                },
                                                {
                                                    label: "o-特殊教學資料",
                                                    value: "o"
                                                },
                                                {
                                                    label: "p-混合性資料",
                                                    value: "p"
                                                },
                                                {
                                                    label: "r-立體藝術品、實物",
                                                    value: "r"
                                                },
                                                {
                                                    label: "t-文字資料(手稿)",
                                                    value: "t"
                                                }
                                            ]}
                                        />
                                    </Form.Item>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="font-medium">7- 書目性質	</TableCell>
                                <TableCell>
                                    <Form.Item
                                        {...field}
                                        name={[field?.name ?? '', 'f7']}
                                        fieldKey={[field?.fieldKey ?? '', 'f7']}
                                        initialValue={initialValues?.f7}
                                    >
                                        <Select
                                            onChange={(value) => {

                                            }}
                                            options={[
                                                {
                                                    label: "a- 單行本之組成部分",
                                                    value: "a"
                                                },
                                                {
                                                    label: "b- 連續性出版品之組成部分",
                                                    value: "b"
                                                },
                                                {
                                                    label: "c- 合集",
                                                    value: "c"
                                                },
                                                {
                                                    label: "d- 子單位",
                                                    value: "d"
                                                },
                                                {
                                                    label: "i- 整合性資源",
                                                    value: "i"
                                                },
                                                {
                                                    label: "m- 圖書式資料（單行本）",
                                                    value: "m"
                                                },
                                                {
                                                    label: "s- 連續性出版品",
                                                    value: "s"
                                                },
                                            ]}

                                        />
                                    </Form.Item>


                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="font-medium">8- 控制類型	</TableCell>
                                <TableCell>
                                    <Form.Item
                                        {...field}
                                        name={[field?.name ?? '', 'f8']}
                                        fieldKey={[field?.fieldKey ?? '', 'f8']}
                                        initialValue={initialValues?.f8}
                                    >
                                        <Select
                                            onChange={(value) => {

                                            }}
                                            options={[
                                                {
                                                    label: "無具體類型",
                                                    value: " "
                                                },
                                                {
                                                    label: "a- 檔案",
                                                    value: "a"
                                                },
                                            ]}

                                        />
                                    </Form.Item>


                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="font-medium">9- 字集	</TableCell>
                                <TableCell>a - UCS/Unicode (自動填充)
                                    <Form.Item
                                        hidden={true}
                                        {...field}
                                        name={[field?.name ?? '', 'f9']}
                                        fieldKey={[field?.fieldKey ?? '', 'f9']}
                                        initialValue={initialValues?.f9}
                                    >
                                        <Input />
                                    </Form.Item>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="font-medium">10-16 指標長度/資料機位/長度	</TableCell>
                                <TableCell>自動填充
                                    <Form.Item
                                        hidden={true}
                                        {...field}
                                        name={[field?.name ?? '', 'f10-16']}
                                        fieldKey={[field?.fieldKey ?? '', 'f10-16']}
                                        initialValue={initialValues?.['f10-16']}
                                    >
                                        <Input />
                                    </Form.Item>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="font-medium">17- 著錄依據及層次	</TableCell>
                                <TableCell>
                                    <Form.Item
                                        {...field}
                                        name={[field?.name ?? '', 'f17']}
                                        fieldKey={[field?.fieldKey ?? '', 'f17']}
                                        initialValue={initialValues?.f17}
                                    >
                                        <Select
                                            onChange={(value) => {

                                            }}
                                            options={[
                                                {
                                                    label: "#- 依資料本身完整著錄",
                                                    value: " "
                                                },
                                                {
                                                    label: "1- 非依資料本身完整著錄",
                                                    value: "1"
                                                },
                                                {
                                                    label: "2- 未非依資料次完整著錄",
                                                    value: "2"
                                                },
                                                {
                                                    label: "3- 簡略著錄層次",
                                                    value: "3"
                                                },
                                                {
                                                    label: "4- 核心著錄層次",
                                                    value: "4"
                                                },
                                                {
                                                    label: "5- 初步(部分)著錄層次",
                                                    value: "5"
                                                },
                                                {
                                                    label: "7- 最低著錄層次",
                                                    value: "7"
                                                },
                                                {
                                                    label: "8- 預行編目著錄層次",
                                                    value: "8"
                                                },
                                                {
                                                    label: "u- 未知",
                                                    value: "u"
                                                },
                                                {
                                                    label: "z- 不適用",
                                                    value: "z"
                                                },
                                            ]}


                                        />
                                    </Form.Item>

                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="font-medium">18 - 記述編目格式	</TableCell>
                                <TableCell>
                                    <Form.Item
                                        {...field}
                                        name={[field?.name ?? '', 'f18']}
                                        fieldKey={[field?.fieldKey ?? '', 'f18']}
                                        initialValue={initialValues?.f18}
                                    >
                                        <Select
                                            options={[
                                                {
                                                    label: "不採用ISBD之格式",
                                                    value: " "
                                                },
                                                {
                                                    label: "a-依據AACR2著錄",
                                                    value: "a"
                                                },
                                                {
                                                    label: "c- ISBD標點符號部分省略",
                                                    value: "c"
                                                },
                                                {
                                                    label: "i- 包含 ISBD 標點符號",
                                                    value: "i"
                                                },
                                                {
                                                    label: "n- 省略非 ISBD 標點符號",
                                                    value: "n"
                                                },
                                                {
                                                    label: "u- 未知",
                                                    value: "u"
                                                },
                                            ]}
                                        />
                                    </Form.Item>

                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="font-medium">19 -層次等級	</TableCell>
                                <TableCell>
                                    <Form.Item
                                        {...field}
                                        name={[field?.name ?? '', 'f19']}
                                        fieldKey={[field?.fieldKey ?? '', 'f19']}
                                        initialValue={initialValues?.f19}
                                    >
                                        <Select
                                            options={[
                                                {
                                                    label: "無從屬關係或關係未定",
                                                    value: " "
                                                },
                                                {
                                                    label: "a- 包含多個單件之紀錄",
                                                    value: "a"
                                                },
                                                {
                                                    label: "b- 各單件紀錄 (題名可獨立之單件）",
                                                    value: "b"
                                                },
                                                {
                                                    label: "c- 各單件紀錄 (題名不可獨立之單件）",
                                                    value: "c"
                                                }
                                            ]}

                                        />
                                    </Form.Item>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="font-medium">20-24 -條目地圖和長度  </TableCell>
                                <TableCell>(自動填充)
                                    <Form.Item
                                        hidden={true}
                                        {...field}
                                        name={[field?.name ?? '', 'f20-24']}
                                        fieldKey={[field?.fieldKey ?? '', 'f20-24']}
                                        initialValue={initialValues?.['f20-24']}
                                    >
                                        <Input />
                                    </Form.Item>

                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Col>



            </Row >
        </>
    );
};


export default LeaderGeneratorForm;
